import { styled, Button } from '@mui/material'

export const StyledCardSelectorButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  cursor: 'pointer',
  width: '100%',
  height: theme.spacing(6),
  padding: 0,
  minHeight: theme.spacing(4),
  background: 'none',
  borderBottom: '1px solid #c4c4c4',
  boxSizing: 'border-box',
  position: 'relative',
  fontSize: '16px',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& .MuiSvgIcon-root': {
    position: 'absolute',
    right: 5,
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    margin: '5px 0 5px 0',
  },
  [theme.breakpoints.down('xs')]: {
    margin: 0,
  },
}))
